export function capitalize(input) {
  return input.charAt(0).toUpperCase() + input.slice(1)
}

export function humanize(input) {
  return capitalize(input)
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z])([0-9])/gi, "$1 $2")
    .replace(/([0-9])([a-z])/gi, "$1 $2")
    .replace(/_+/g, " ")
}

export function titleize(input) {
  return humanize(input)
    .toLowerCase()
    .replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase())
}

export function snakecase(input) {
  if (!input) return input
  return input
    .replace(/[A-Z]/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : `_${word.toLowerCase()}`
    })
    .replace(/\s/g, "")
}

export function camelize(input) {
  return input.replace(/^\w|_\w|-\w/g, (word) =>
    word.replace(/_|-/g, "").toUpperCase()
  )
}

export function camelizeLower(input) {
  return input
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    )
}

export function classify(input) {
  return titleize(input).replace(/\W/g, "")
}

export function underscore(input) {
  if (!input) return input
  return input.toLowerCase().replace(/\s/g, "_")
}

export function removeUnderscore(input) {
  if (!input) return input
  return input.toLowerCase().replace(/_/g, " ")
}

export function hyphenate(input) {
  if (!input) return input
  return input.toLowerCase().replace(/\s/g, "-")
}

const UNCOUNTABLE = ["equipment"]
const IRREGULAR = {
  person: "people",
}
const PLURAL_PATTERNS = [[/([^aeiouy]|qu)y$/i, "$1ies"]]

export function pluralize(word, count) {
  if (count !== 0 && count !== undefined && (count === 1 || count === -1)) {
    return word
  }

  if (typeof word !== "string") return word
  if (word.endsWith("s")) return word
  if (UNCOUNTABLE.includes(word)) return word

  if (word in IRREGULAR) return IRREGULAR[word]

  for (const pluralPattern of PLURAL_PATTERNS) {
    const [pattern, replacement] = pluralPattern

    if (word.match(pattern)) {
      return word.replace(pattern, replacement)
    }
  }

  return `${word}s`
}

export const truncateText = (text, maxLength = 8) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
